import React from 'react';
import * as XLSX from 'xlsx';
import Spreadsheet from 'x-data-spreadsheet';
import 'x-data-spreadsheet/dist/xspreadsheet.css';

function stox(wb) {
  const out = [];

  wb.SheetNames.forEach((name) => {
    const o = { name, rows: {}, cols: [] };
    const ws = wb.Sheets[name];

    if (!ws || !ws['!ref']) return;

    const aoa = XLSX.utils.sheet_to_json(ws, {
      raw: false,
      header: 1,
      defval: '',
      blankrows: true,
    });

    const colWidths = [];

    aoa.forEach((row, i) => {
      const cells = {};
      row.forEach((c, j) => {
        const text = c?.toString() ?? '';
        const cellRef = XLSX.utils.encode_cell({ r: i, c: j });

        colWidths[j] = Math.max(colWidths[j] || 10, text.length * 8);

        cells[j] = { text };
        if (ws[cellRef]?.f) {
          cells[j].text = '=' + ws[cellRef].f;
        }
      });
      o.rows[i] = { cells };
    });

    o.cols = colWidths.map((w) => ({
      width: Math.min(Math.max(w, 60), 400),
    }));

    o.merges = [];
    (ws['!merges'] || []).forEach((merge) => {
      if (merge.e.r >= merge.s.r && merge.e.c >= merge.s.c) {
        if (!o.rows[merge.s.r]) o.rows[merge.s.r] = { cells: {} };
        if (!o.rows[merge.s.r].cells[merge.s.c]) {
          o.rows[merge.s.r].cells[merge.s.c] = {};
        }
        o.rows[merge.s.r].cells[merge.s.c].merge = [
          merge.e.r - merge.s.r,
          merge.e.c - merge.s.c,
        ];
        o.merges.push(XLSX.utils.encode_range(merge));
      }
    });

    out.push(o);
  });

  return out;
}

function ExcelViewer({ document }) {
  const ref = React.useRef();
  const instanceRef = React.useRef(null);

  React.useEffect(() => {
    if (!document?.data) return;

    const loadExcel = async () => {
      try {
        const arrayBuffer = await document.data.arrayBuffer();
        const wb = XLSX.read(arrayBuffer, { type: 'array' });

        if (!wb.SheetNames?.length) {
          console.warn('Workbook kosong');
          return;
        }

        const data = stox(wb);
        console.log('Jumlah sheet:', data.length);
        console.log('Sheet pertama, jumlah rows:', Object.keys(data[0].rows).length);

        if (instanceRef.current) {
          ref.current.innerHTML = '';
          instanceRef.current = null;
        }

        instanceRef.current = new Spreadsheet(ref.current, {
            mode: 'read',
            showToolbar: false,
            row: { len: Object.keys(data[0].rows).length + 50 },
            view: {
                height: () => ref.current?.offsetHeight || window.innerHeight - 200,
                width: () => ref.current?.offsetWidth || window.innerWidth - 200,
            },
        });

        instanceRef.current.loadData(data);
        instanceRef.current.change(0);
      } catch (err) {
        console.error('Gagal menampilkan Excel:', err);
      }
    };

    loadExcel();
  }, [document]);

  return (
    <div
      id="spreadsheet"
      ref={ref}
      style={{ border: '1px solid #ccc', minHeight: 500, width: '100%' }}
    />
  );
}

export default ExcelViewer;
